import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ServerService} from "./ServerService";

@Injectable({
  providedIn: 'root'
})
export class FiadosService extends ServerService {
  constructor(http: HttpClient) {
    super(http);
  }

  private normalizeFiltro(filtro: any = {}) {
    const dados: any = {...filtro};

    if(dados.todos === true || dados.todos === 'true')
      dados.todos = true;
    else
      delete dados.todos;
    if(!dados.q) delete dados.q;
    if(!dados.di) delete dados.di;
    if(!dados.df) delete dados.df;
    if(!dados.idContato) delete dados.idContato;

    return dados;
  }

  listeLancamentos(filtro: any = {}) {
    return this.obtenha('/fiados', this.normalizeFiltro(filtro));
  }

  listeLancamentosCliente(idContato: number, filtro: any = {}) {
    return this.obtenha(`/fiados/cliente/${idContato}`, this.normalizeFiltro(filtro));
  }

  quiteLancamentos(dados: any) {
    return this.facaPost('/fiados/acertos', dados);
  }

  obtenhaConta(idContato: number) {
    return this.obtenha(`/fiados/conta/${idContato}`, {});
  }

  listeMovimentosConta(idContato: number, filtro: any = {}) {
    return this.obtenha(`/fiados/conta/${idContato}/movimentos`, this.normalizeFiltro(filtro));
  }

  adicioneCredito(dados: any) {
    return this.facaPost('/fiados/creditos', dados);
  }

  listeAcertos(filtro: any = {}) {
    return this.obtenha('/fiados/acertos', this.normalizeFiltro(filtro));
  }

  obtenhaAcerto(id: number) {
    return this.obtenha(`/fiados/acertos/${id}`, {});
  }
}
